import axios from "axios";

import { API_URL } from "../constants";

export class DecryptToken {
    static decryptToken = (encryptedToken) => {
        let request = axios.create({
            baseURL: API_URL,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return request.post('api/security/decrypt_token', {
            encrypted_token: encryptedToken,
        });
    }
}
